import { cn } from "@/lib/utils";

/** A long text value truncated to one line, with the full text as a native tooltip. */
export function TruncatedText({ value, className }: { value?: string; className?: string }) {
  if (!value) return null;
  return (
    <span title={value} className={cn("block max-w-[220px] truncate", className)}>
      {value}
    </span>
  );
}

export function formatCellValue(value: string | number | boolean | undefined): string {
  if (value === undefined) return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}
